import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import register from '@/components/register'
import forgetpassword from '@/components/forgetpassword'
import sellerlogin from '@/components/sellerlogin'
import sellerregister from '@/components/sellerregister'
import sellerforgetpassword from '@/components/sellerforgetpassword'
import selectareacode from '@/components/selectareacode'
import guidePage from '@/components/guidePage'
import index from '@/components/index'
import orderlist from '@/components/orderlist'
import orderdetails from '@/components/orderdetails'
import commodity from '@/components/commodity'
import seletcattribute from '@/components/seletcattribute'
import shop from '@/components/shop'
import shoppingcart from '@/components/shoppingcart'
import productedit from '@/components/productedit'
import selecttime from '@/components/selecttime'
import setaddress from '@/components/setaddress'
import touristshop from '@/components/touristshop'
import signature from '@/components/signature'
import delivery_details from '@/components/delivery_details'

import childorderdetails from '@/components/orderlist_child/childorderdetails'
import delivery from '@/components/orderlist_child/delivery'
import manage_devices from '@/components/orderlist_child/manage_devices'
import my_account from '@/components/orderlist_child/my_account'
import equipment_details from '@/components/orderlist_child/equipment_details'
import customer from '@/components/orderlist_child/customer'
import point from '@/components/orderlist_child/point'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'sellerlogin',
      component: sellerlogin
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/forgetpassword',
      name: 'forgetpassword',
      component: forgetpassword
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/sellerregister',
      name: 'sellerregister',
      component: sellerregister
    },
    {
      path: '/sellerforgetpassword',
      name: 'sellerforgetpassword',
      component: sellerforgetpassword
    },
    {
      path: '/selectareacode',
      name: 'selectareacode',
      component: selectareacode
    },
    {
      path: '/guidePage',
      name: 'guidePage',
      component: guidePage
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/orderlist',
      name: 'orderlist',
      component: orderlist,
      redirect: '/orderlist/childorderdetails',
      children: [
        {
          path: 'childorderdetails',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'childorderdetails',
          component: childorderdetails
        },
        {
          path: 'delivery',
          name: 'delivery',
          component: delivery
        },
        {
          path: 'manage_devices',
          name: 'manage_devices',
          component: manage_devices
        },
        {
          path: 'equipment_details',
          name: 'equipment_details',
          component: equipment_details
        },
        {
          path: 'my_account',
          name: 'my_account',
          component: my_account
        },
        {
          path: 'customer',
          name: 'customer',
          component: customer
        },
        {
          path: 'point',
          name: 'point',
          component: point
        },
      ]
    },
    {
      path: '/orderdetails',
      name: 'orderdetails',
      component: orderdetails
    },
    {
      path: '/commodity',
      name: 'commodity',
      component: commodity,
    },
    {
      path: '/seletcattribute',
      name: 'seletcattribute',
      component: seletcattribute,
    },
    {
      path: '/shop',
      name: 'shop',
      component: shop,
    },
    {
      path:'/selecttime',
      name:'selecttime',
      component:selecttime
    },
    {
      path:'/setaddress',
      name:'setaddress',
      component:setaddress
    },
    {
      path: '/shoppingcart',
      name: 'shoppingcart',
      component: shoppingcart
    },
    {
      path: '/delivery_details',
      name: 'delivery_details',
      component: delivery_details
    },
    {
      path: '/productedit',
      name: 'productedit',
      component: productedit
    },
    {
      path: '/touristshop',
      name: 'touristshop',
      component: touristshop
    },
    {
      path: '/signature',
      name: 'signature',
      component: signature
    }
  ],
})





// WEBPACK FOOTER //
// ./src/router/index.js